declare global {
    interface Window {
        dataLayer?: object[];
    }
}

export const sendGTMEvent = (data: object): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
};
